import { RRule } from 'rrule';

export const MEMBERSHIP = {
  COUNT: 'COUNT',
  POINT: 'POINT'
};

export const TIME_UNIT = {
  MINUTE: 1,
  HOUR: 60,
  DAY: 60 * 24
};

export const DAY_UNIT = {
  DAY: 1,
  MONTH: 30,
  YEAR: 365
};

export const INLINE_FORM_MODE = {
  FORM: 'FORM',
  VIEW: 'VIEW'
};

export const CENTER_STATUS = {
  POLICY: 'POLICY',
  INSTRUCTOR: 'INSTRUCTOR',
  COURSE: 'COURSE',
  MEMBERSHIP: 'MEMBERSHIP',
  DONE: 'DONE'
};

export const CENTER_SUBSCRIBE_STATUS = {
  // 체험판
  POLICY: 'TRIAL',
  INSTRUCTOR: 'TRIAL',
  COURSE: 'TRIAL',
  MEMBERSHIP: 'TRIAL',
  DONE: 'TRIAL',
  // 이용중
  WHITE: 'SUBSCRIBING',
  GREY: 'SUBSCRIBING',
  BLACK: 'SUBSCRIBING',
  // 만료됨
  EXPIRED: 'EXPIRED',
  TRIAL: 'TRIAL',
  SUBSCRIBING: 'SUBSCRIBING'
};

export const CALENDAR_DATE_UNIT = {
  daily: 'Day',
  weekly: 'Week',
  monthly: 'Month'
};

export const COURSE_DIALOG_TAB = {
  COURSE_INFO: 'course-info',
  BOOKING: 'booking',
  BOOKING_HISTORY: 'booking-history'
};

export const ACCOUNT_ROLE = {
  OWNER: 0,
  INSTRUCTOR: 1
};

export const BOOKING_FAIL_MESSAGES = {
  '101': {
    type: 'message',
    message: '예약이 차단된 날짜입니다.'
  },
  '102': {
    type: 'message',
    message: '지금은 출석체크가 불가합니다.'
  },
  '103': {
    type: 'message',
    message: '정원 마감된 수업으로 예약할 수 없습니다.'
  },
  '104': {
    type: 'message',
    message: '예약에 오류가 발생하였습니다.'
  },
  '105': {
    type: 'message',
    message: '현재 본 수업은 예약이 불가합니다.'
  },
  '106': {
    type: 'message',
    message: '현재 본 수업은 예약 취소가 불가합니다.'
  },
  '107': {
    type: 'message',
    message: '현재 본 수업은 예약 변경이 불가합니다.'
  },
  '108': {
    type: 'member-confirm',
    message:
      '님은 본 수업의 수강 권한이 없습니다. 회원 상세 페이지로 이동하여 수강 가능한 수업을 수정해주시길 바랍니다.'
  },
  POINT: {
    // 분기 필요
    type: 'alert',
    title: '포인트 부족',
    message: '해당 수업 예약에 필요한 포인트가 부족합니다.'
  },
  COUNT: {
    type: 'alert',
    title: '예약 가능 횟수 초과',
    message: '예약 가능 횟수를 초과하셨습니다.'
  },
  '110': {
    type: 'message',
    message: '회원권이 유효하지 않습니다.'
  },
  '111': {
    type: 'message',
    message: '일일 최대 예약 횟수를 초과하셨습니다.'
  },
  '112': {
    type: 'alert',
    title: '출석체크 불가',
    message:
      '현재 위치에서 출석 확인이 불가합니다. 500m 이내로 이동해주시기 바랍니다.'
  },
  '113': {
    type: 'message',
    message: '현재 시점에서 예약 상태를 변경하실 수 없습니다.'
  },
  '114': {
    type: 'message',
    message: '주간 최대 예약 횟수를 초과하셨습니다.'
  },
  '115': {
    type: 'message',
    message: '이미 출석체크한 수업입니다.'
  },
  '801': {
    type: 'message',
    message: '홀딩 기간입니다.'
  }
};

export const ATTEND_FAIL_MESSAGES = {
  '101': {
    type: 'message',
    message: '예약이 차단된 날짜입니다.'
  },
  '102': {
    type: 'message',
    message: '지금은 출석체크가 불가합니다.'
  },
  '103': {
    type: 'message',
    message: '정원 마감된 수업으로 출석체크할 수 없습니다.'
  },
  '104': {
    type: 'message',
    message: '예약에 오류가 발생하였습니다.'
  },
  '105': {
    type: 'message',
    message: '현재 본 수업은 예약이 불가합니다.'
  },
  '106': {
    type: 'message',
    message: '현재 본 수업은 예약 취소가 불가합니다.'
  },
  '107': {
    type: 'message',
    message: '현재 본 수업은 예약 변경이 불가합니다.'
  },
  '108': {
    type: 'member-confirm',
    message:
      '본 수업의 수강 권한이 없습니다. 관리자에게 수강 권한 배정을 요청해 주시길 바랍니다.'
  },
  POINT: {
    // 분기 필요
    type: 'alert',
    title: '포인트 부족',
    message: '해당 수업 예약에 필요한 포인트가 부족합니다.'
  },
  COUNT: {
    type: 'alert',
    title: '예약 가능 횟수 초과',
    message: '예약 가능 횟수를 초과하셨습니다.'
  },
  '110': {
    type: 'message',
    message: '회원권이 유효하지 않습니다.'
  },
  '111': {
    type: 'message',
    message: '일일 최대 예약 횟수를 초과하셨습니다.'
  },
  '112': {
    type: 'alert',
    title: '출석체크 불가',
    message:
      '현재 위치에서 출석 확인이 불가합니다. 500m 이내로 이동해주시기 바랍니다.'
  },
  '113': {
    type: 'message',
    message: '현재 시점에서 예약 상태를 변경하실 수 없습니다.'
  },
  '114': {
    type: 'message',
    message: '주간 최대 예약 횟수를 초과하셨습니다.'
  },
  '115': {
    type: 'message',
    message: '이미 출석체크한 수업입니다.'
  },
  '118': {
    type: 'message',
    message: '예약이 차단된 수업입니다.'
  },
  '119': {
    type: 'message',
    message: '최대 일일 예약횟수를 초과했습니다.'
  },
  '120': {
    type: 'message',
    message: '최대 주간 예약횟수를 초과했습니다.'
  },
  '801': {
    type: 'message',
    message: '홀딩 기간입니다.'
  }
};

export const FREQUENCY_OPTIONS = [
  {
    value: 0,
    label: '반복 안함'
  },
  {
    value: 1,
    label: '매주 개설'
  },
  {
    value: 2,
    label: '2주마다 개설'
  },
  {
    value: 3,
    label: '3주마다 개설'
  },
  {
    value: 4,
    label: '4주마다 개설'
  }
];

export const WEEKDAY_OPTIONS = [
  {
    label: '월',
    value: RRule.MO
  },
  {
    label: '화',
    value: RRule.TU
  },
  {
    label: '수',
    value: RRule.WE
  },
  {
    label: '목',
    value: RRule.TH
  },
  {
    label: '금',
    value: RRule.FR
  },
  {
    label: '토',
    value: RRule.SA
  },
  {
    label: '일',
    value: RRule.SU
  }
];

export const LOCKER_STATUS = {
  EMPTY: 0,
  OCCUPIED: 1,
  SCHEDULED: 2
};

export const BOOKING_EXPIRED_STANDARD = {
  CANCELABLE: 0,
  CHANGEABLE: 1,
  AVALIABLE: 2
};

export const RESTRICT_FUNCTION_ID = {
  POINT: 'point',
  TIME_OPEN: 'time_open',
  SHOW_REMAIN: 'show_remaining',
  PUSH_ALERT: 'pushalert_remind',
  WAITLIST: 'waitlist',
  TIME_FIXED: 'time_fixed',
  TIME_APPLY: 'time_apply',
  TIME_EDIT: 'time_edit',
  TIME_CANCEL: 'time_cancel',
  TIME_CHECKIN: 'time_checkin',
  TIME_LATE: 'time_late'
};

export const RESTRICT_FUNCTION_NAME = {
  point: '포인트제',
  time_open: '예약 오픈 시점',
  show_remaining: '잔여 인원 노출',
  pushalert_remind: '수업 리마인드 푸시 알림',
  waitlist: '예약 대기',
  time_fixed: '예약 확정 시간',
  time_apply: '예약 가능 시간',
  time_edit: '예약 변경 가능 시간',
  time_cancel: '예약 취소 가능 시간',
  time_checkin: '출석 체크 가능 시간',
  time_late: '지각 처리 시작 기준'
};

export const RESTRICT_FUNCTION_MESSAGE = {
  point:
    "포인트제로 설정하면 수업 횟수 차감 단위가 ‘회'가 아닌 'P’로 일괄 적용됩니다. 수업 별로 금액이 상이하거나 다양한 수업을 운영하시는 곳이라면 포인트제를 권장 드립니다.",
  time_open:
    "수업일 기준 며칠/몇 주 전/몇 시에 예약을 오픈할지 직접 설정하실 수 있습니다. 기본 설정된 예약 오픈 시점은 '수업일 기준 1일 전 00:00’ 입니다.",
  show_remaining:
    '잔여 인원 노출을 설정하면 앱에서 모든 수업의 잔여 인원이 표시됩니다. 현재는 앱에서 잔여 인원을 확인할 수 없습니다.',
  pushalert_remind:
    '알림을 설정하면 예약 회원에게 수업 시작 전 리마인드 푸시 알림이 무료 발송됩니다. 수업 시작 몇 분/시간/일 전에 발송할지도 자유롭게 설정하실 수 있습니다.',
  waitlist:
    '예약 대기 기능을 설정하면 예약 정원이 마감되더라도 회원이 앱으로 예약 대기를 신청할 수 있습니다. 결원 발생 시마다 대기자 선착순으로 자동 충원되며 확정자에게 예약 완료 푸시 알림이 발송됩니다. 스케줄에 등록된 각 수업마다 대기 기능을 설정할 수 있습니다.',
  time_fixed:
    '대기자를 포함한 최종 예약 리스트를 확정시킬 기준을 직접 선택하실 수 있습니다.',
  time_apply:
    "원하는 예약 가능 시간을 직접 설정하실 수 있습니다. 기본 설정된 예약 가능 시간은 '수업 시작 30분 전까지’ 입니다.",
  time_edit:
    "원하는 예약 변경 가능 시간을 직접 설정하실 수 있습니다. 기본 설정된 예약 변경 가능 시간은 '수업 시작 5시간 전까지’입니다.",
  time_cancel:
    "원하는 예약 취소 가능 시간을 직접 설정하실 수 있습니다. 기본 설정된 예약 취소 가능 시간은 '수업 1일 전까지’입니다.",
  time_checkin:
    "원하는 출석체크 가능 시간을 직접 설정하실 수 있습니다. 기본 설정된 출석체크 가능 시간은 '수업 시작 10분 전까지’입니다.",
  time_late:
    "원하는 지각 처리 시작 기준을 직접 설정하실 수 있습니다. 기본 설정된 지각 처리 시작 기준은 '수업 시작 5분전’입니다."
};

export const VALIDATION_MESSAGE = {
  '300': {
    type: 'alert',
    title: '이모지 입력 불가',
    message:
      '입력하신 이모지는 사용할 수 없습니다. 이모지를 제외하고 저장해 주시길 바랍니다. '
  }
};
